import React from "react";
import { Button, Spinner } from "reactstrap";

interface CustomButtonProps {
  text: string;
  onClick?: () => void;
  type?: "button" | "submit";
  loading?: boolean;
  disabled?: boolean;
  className?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  newClassName?: string;
  textClassName?: string;
  textColor?: string;
  showTextWhileLoading?: boolean;
  id?: string;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  text,
  onClick,
  type = "button",
  loading = false,
  disabled = false,
  className = "",
  leftIcon,
  rightIcon,
  newClassName,
  textClassName,
  textColor = "text-white",
  showTextWhileLoading = false,
  id,
}) => {
  return (
    <Button
      id={id}
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={
        newClassName
          ? `d-flex btn-press-effect ${newClassName}`
          : `d-flex align-items-center justify-content-center gap-2 border-0 btn-press-effect ${className}`
      }
    >
      {loading ? (
        <>
          <Spinner size="sm" />
          {showTextWhileLoading && (
            <span
              className={`fs-14 fw-normal font-primary ${textClassName} ${textColor}`}
              style={{ visibility: "hidden" }}
            >
              {text}
            </span>
          )}
        </>
      ) : (
        <>
          {/* Left icon */}
          {leftIcon && (
            <span className="d-flex align-items-center">{leftIcon}</span>
          )}

          {/* Text */}
          <span
            className={`fs-14 fw-normal font-primary ${textClassName} ${textColor}`}
          >
            {text}
          </span>

          {/* Right icon */}
          {rightIcon && (
            <span className="d-flex align-items-center">{rightIcon}</span>
          )}
        </>
      )}
    </Button>
  );
};

export default CustomButton;
